import { useEffect, useState } from "react";
import Table from '../../Table/Table';
import config from '../../../config';
import 'react-datepicker/dist/react-datepicker.css';
import { Link, useNavigate } from 'react-router-dom';
import { Download, Eye } from 'lucide-react';

const Invoice = () => {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const columns = [
        "ID", "Invoice No", "Date/Time", "Type", "Customer", "Customer Office", "Purchase Order No", "Store",
        "Transaction Type", "Creadit Pay", "Due", "Purchase Order img/pdf", "Print"
    ];

    useEffect(() => {
        fetchSalesHistory();
    }, []);

    const fetchSalesHistory = async () => {
        setIsLoading(true);
        setError(null);
        try {
            const response = await fetch(`${config.BASE_URL}/invoices`);
            if (!response.ok) {
                throw new Error('Failed to fetch Sales Invoices');
            }
            const invoices = await response.json();

            const filteredInvoices = invoices
                .filter(invoice => invoice.status === "invoice" && invoice.draft === "false" && invoice.store === "Colkan" || invoice.store === "TerraWalkers") 
                .sort((a, b) => a.invoiceId - b.invoiceId);

            const transactionPromises = filteredInvoices.map(async (invoice) => {
                try {
                    const transactionResponse = await fetch(`${config.BASE_URL}/transaction/invoice/${invoice.invoiceId}`);
                    if (transactionResponse.ok) {
                        return await transactionResponse.json();
                    }
                } catch (error) {
                    console.error("Transaction fetch error:", error);
                }
                return [];
            });

            const transactionsData = await Promise.all(transactionPromises);

            const formattedData = filteredInvoices.map((invoice, index) => {
                const invoiceDate = new Date(invoice.invoiceDate);
                const formattedInvoiceDate = `${String(invoiceDate.getHours()).padStart(2, '0')}:${String(invoiceDate.getMinutes()).padStart(2, '0')} ${String(invoiceDate.getDate()).padStart(2, '0')}-${String(invoiceDate.getMonth() + 1).padStart(2, '0')}-${invoiceDate.getFullYear()}`;

                const transactionPrice = transactionsData[index]?.reduce((total, transaction) => total + transaction.paid, 0) || 0;
                const transactionDue = transactionsData[index]?.reduce((total, transaction) => total + transaction.due, 0) || 0;
                const transactionTypes = transactionsData[index]?.map((transaction) => transaction.transactionType).join(', ') || "-";

                const filename = invoice.image ? invoice.image.split('/').pop() : null;
                const currentYear = invoiceDate.getFullYear().toString().slice(-2);

                let invoiceName = ''
                if (invoice.store === 'Haman') {
                    invoiceName = 'HN-INV-'
                } if (invoice.store === 'Colkan' || invoice.store === 'TerraWalkers') {
                    invoiceName = 'INV-'
                }

                return [
                    invoice.invoiceId,
                    invoiceName + invoice.invoiceNo + '-' + currentYear,
                    formattedInvoiceDate,
                    invoice.status,
                    invoice.customer?.cusName || "-",
                    invoice.customer?.cusOffice || "-",
                    invoice.purchaseNo || "-",
                    invoice.store || "-",
                    transactionTypes || "-",
                    transactionPrice.toFixed(2) || "-",
                    transactionDue.toFixed(2) || "-",
                    filename ? (
                        <a href={`${config.BASE_URL}/download/invoice/${filename}`} download>
                            <button className="btn btn-success" style={{ fontSize: "12px" }}><Download /></button>
                        </a>
                    ) : "No Image",
                    <Link to={`/createInvoice/${invoice.store}/${invoice.invoiceNo}`}>
                        <button className="btn btn-primary" style={{ fontSize: "12px" }}>Print</button>
                    </Link>,
                ];
            });

            setData(formattedData);
        } catch (err) {
            console.error("Fetch Sales History Error:", err);
            setError(err.message);
        } finally {
            setIsLoading(false);
        }
    };

    const title = 'History';
    const invoice = 'History.pdf';

    const handleDelete = async (originalIndex) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this invoice?");
        if (!confirmDelete) return;

        const invoiceId = data[originalIndex][0];

        try {
            const response = await fetch(`${config.BASE_URL}/invoice/${invoiceId}`, { method: 'DELETE' });
            if (!response.ok) {
                const message = await response.text();
                throw new Error(`Failed to delete invoice: ${message}`);
            }

            const updatedData = data.filter(item => item[0] !== invoiceId);
            setData(updatedData);
        } catch (err) {
            setError(err.message);
        }
    };

    const invoiceType = "invoice";
    const navigate = useNavigate();

    return (
        <div>
            <div className="scrolling-container">
                <div className="new-sales-container">
                    <h4>Invoice</h4>

                    {isLoading ? (
                        <p>Loading...</p>
                    ) : error ? (
                        <p>Error: {error}</p>
                    ) : (<p></p>)}

                    <div className="payment-form-button d-grid d-md-flex me-md-2 justify-content-end">
                        <Link to={`/sales/new/${invoiceType}`}>
                            <button className="btn btn-warning" style={{ fontSize: "13px" }}>Create Sales Invoice</button>
                        </Link>
                    </div>

                    <Table
                        data={data}
                        columns={columns}
                        title={title}
                        invoice={invoice}
                        onEdit={(originalIndex) => {
                            const invoiceId = data[originalIndex][0];
                            navigate(`/DraftSales/${invoiceId}/${invoiceType}`);
                        }}
                        showButton={false}
                        onDelete={handleDelete}
                        itemsPerPageOptions={[10, 25, 50, 100, -1]} // Customize as needed
                    />
                </div>
            </div>
        </div>
    );
};

export default Invoice;